import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { ATHLETES } from "../../constants";
import { coach } from "../../constants";
import { FaTimes, FaFacebookF, FaInstagram } from "react-icons/fa";
import PrimaryButton from "../../UI/PrimaryButton";

const Athletes = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);

  const openModal = (person) => {
    setSelectedPerson(person);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedPerson(null);
  };

  useEffect(() => {
    if (modalIsOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [modalIsOpen]);

  return (
    <div className="container mx-auto px-6 py-12 min-h-screen mt-10 lg:mt-20mt-20">
      {/* Coach Section */}
      <div className="mb-12 flex flex-col">
        <h2 className="text-3xl md:text-4xl text-center font-bold mb-6">
          Coach
        </h2>
        <div className="w-full border-1 border-gray-200 sm:w-3/4 md:w-2/3 lg:w-1/2 mx-auto bg-white rounded-lg shadow-lg overflow-hidden transform transition-transform duration-300 cursor-pointer hover:shadow-xl">
          <div
            className="w-full h-64 md:h-80 bg-cover bg-center"
            style={{
              backgroundImage: `url(${coach.image})`,
              backgroundColor: "#09263a", // Fallback color
            }}
          />
          <div className="p-6">
            <h2 className="text-xl md:text-2xl font-bold text-baseBlue mb-2">
              {coach.name}
            </h2>
            <p className="text-baseBlue mb-4">{coach.description}</p>
          </div>
          <div className="px-3 pb-3">
            <PrimaryButton text="READ MORE" onClick={() => openModal(coach)} />
          </div>
        </div>
      </div>

      {/* Athletes Section */}
      <div>
        <h2 className="text-3xl md:text-4xl text-center font-bold mb-6">
          Athletes
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {ATHLETES.map((athlete) => (
            <div
              key={athlete.id}
              className="flex flex-col rounded-lg shadow-lg overflow-hidden transform transition-transform duration-300 cursor-pointer hover:shadow-xl"
            >
              <div
                className="w-full h-96 lg:h-[500px] bg-cover bg-center"
                style={{
                  backgroundImage: `url(${athlete.image})`,
                  backgroundColor: "#09263a",
                  backgroundPosition: "top",
                  backgroundSize: "fit"
                }}
              />
              <div className="p-6 flex-1">
                <h2 className="text-xl md:text-2xl font-bold text-baseBlue mb-2">
                  {athlete.name}
                </h2>
                {/* <p className="text-baseBlue mb-4">{athlete.description}</p> */}
              </div>
              <div className="px-3 pb-3">
                <PrimaryButton
                  text="READ MORE"
                  onClick={() => openModal(athlete)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Person Information"
        className="fixed inset-0 flex items-center justify-center p-4"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-10"
      >
        {selectedPerson && (
          <div className="bg-white max-h-[95vh] overflow-y-auto w-full max-w-md md:max-w-lg p-6 rounded-lg shadow-lg relative">
            <button
              className="absolute top-4 right-4 text-baseBlue hover:text-baseBlue"
              onClick={closeModal}
              aria-label="Close Modal"
            >
              <FaTimes size={24} />
            </button>
            <div className="flex flex-col items-center">
              <img
                src={selectedPerson.image}
                alt=""
                className="h-24 rounded-full mb-4"
              />
              <h2 className="text-xl md:text-2xl font-bold text-baseBlue mb-2">
                {selectedPerson.name}
              </h2>
              <div className="text-baseBlue flex flex-col items-center justify-center gap-2 mt-4 mb-8 font-bold">
                {selectedPerson.details.map(achievment => {
                  return <div className="text-center">{achievment}</div>
                })}
              </div>
              <div className="flex space-x-4 mb-4">
                {selectedPerson.social?.facebook && (
                  <a
                    href={selectedPerson.social.facebook}
                    target="_blank"
                    rel="noreferrer"
                    className="text-baseBlue hover:text-baseGreen text-2xl"
                  >
                    <FaFacebookF />
                  </a>
                )}
                {selectedPerson.social?.instagram && (
                  <a
                    href={selectedPerson.social.instagram}
                    target="_blank"
                    rel="noreferrer"
                    className="text-baseBlue hover:text-baseGreen text-2xl"
                  >
                    <FaInstagram />
                  </a>
                )}
              </div>
              <PrimaryButton text="CLOSE" onClick={closeModal} />
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default Athletes;
